function safeJsonParse(value, fallback) {
  if (value === null || value === undefined || value === '') {
    return fallback
  }
  if (typeof value !== 'string') {
    return value
  }
  try {
    return JSON.parse(value)
  } catch (error) {
    return fallback
  }
}

function normalizePlanWhiteListItem(item) {
  if (item === null || item === undefined) {
    return ''
  }
  let val = ''
  if (typeof item === 'object') {
    if (item.adId !== undefined && item.adId !== null) {
      val = String(item.adId).trim()
    } else if (item.id !== undefined && item.id !== null) {
      val = String(item.id).trim()
    } else if (item.value !== undefined && item.value !== null) {
      val = String(item.value).trim()
    } else if (item.label !== undefined && item.label !== null) {
      val = String(item.label).trim()
    }
  } else {
    val = String(item).trim()
  }

  // 1. 如果包含 "ID：" 或 "ID:" (不区分大小写)，尝试提取其后的数字部分
  const idMatch = val.match(/id[：:]\s*(\d+)/i)
  if (idMatch) {
    return idMatch[1]
  }

  // 2. 否则，移除所有非数字字符
  const cleaned = val.replace(/\D+/g, '')

  // 3. 限制最少长度（例如计划 ID 最少 10 位以上，避免把无关数字当成 ID）
  if (cleaned.length >= 10) {
    return cleaned
  }

  // 若不符合长度或规范，返回空串，系统将自动忽略此项的添加
  return ''
}

export function normalizePlanWhiteList(list) {
  const rawList = Array.isArray(list)
    ? list
    : typeof list === 'string'
      ? list.split(/[\s,，、]+/)
      : list && typeof list === 'object'
        ? [list]
        : []

  const uniqueList = []
  const seen = new Set()

  rawList.forEach((item) => {
    const value = normalizePlanWhiteListItem(item)
    if (!value || seen.has(value)) {
      return
    }
    seen.add(value)
    uniqueList.push(value)
  })

  return uniqueList
}

export function buildPlanWhiteListOptions(list) {
  const options = []
  const seen = new Set()

  ;(Array.isArray(list) ? list : []).forEach((item) => {
    const value = normalizePlanWhiteListItem(item)
    if (!value || seen.has(value)) {
      return
    }
    seen.add(value)
    const name = item && typeof item === 'object'
      ? item.name || item.productName || item.label || value
      : value
    options.push({
      value,
      label: `${name} (${value})`,
    })
  })

  return options
}

export function parseMonitorObjectInfo(raw) {
  const parsed = safeJsonParse(raw, raw)

  if (Array.isArray(parsed)) {
    return {
      selectedMonitorList: parsed,
      planWhiteList: [],
    }
  }

  if (parsed && typeof parsed === 'object') {
    const selectedMonitorList = Array.isArray(parsed.selectedMonitorList)
      ? parsed.selectedMonitorList
      : Array.isArray(parsed.monitorList)
        ? parsed.monitorList
        : Array.isArray(parsed.monitorObjectList)
          ? parsed.monitorObjectList
          : []

    return {
      selectedMonitorList,
      planWhiteList: normalizePlanWhiteList(
        parsed.planWhiteList ||
        parsed.planWhitelist ||
        parsed.planWhitelistIds ||
        parsed.whiteList
      ),
    }
  }

  return {
    selectedMonitorList: [],
    planWhiteList: [],
  }
}

export function buildMonitorObjectInfo(selectedMonitorList, planWhiteList) {
  return JSON.stringify({
    selectedMonitorList: Array.isArray(selectedMonitorList) ? selectedMonitorList : [],
    planWhiteList: normalizePlanWhiteList(planWhiteList),
  })
}

export function getPlanWhiteListSummary(raw) {
  const planWhiteList = normalizePlanWhiteList(raw)
  if (!planWhiteList.length) {
    return ''
  }
  if (planWhiteList.length <= 3) {
    return planWhiteList.join('、')
  }
  return `${planWhiteList.slice(0, 3).join('、')} 等${planWhiteList.length}条`
}
